import { useRef, useState } from "react";
import { SpeakerSimpleHigh, SpeakerSimpleX } from "@phosphor-icons/react";

// 📼 Paste Ryan's video URL (mp4/webm) to play it inside the tube TV.
const TV_VIDEO = "";
const TICKER = ["MR. WIGGLEZ", "LOUD & LOYAL", "ADOPT DON'T SHOP", "KING · BEATS · SMILEY", "$3M RANCH", "300 ACRES", "3,000 PITS SAVED"];

export default function RetroTV() {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggle = () => {
    const v = ref.current;
    if (!v) return;
    v.muted = !v.muted;
    setMuted(v.muted);
    if (!v.muted) v.play().catch(() => {});
  };

  return (
    <section className="relative bg-black py-20 overflow-hidden" data-testid="retro-tv">
      <div className="absolute inset-0 grain opacity-40" />
      <div className="relative max-w-4xl mx-auto px-5 sm:px-8 text-center">
        <p className="overline text-primary mb-3">Live from the Empire · CH 69</p>
        <h2 className="font-display text-3xl sm:text-4xl mb-8">The <span className="neon-text">Wigglez</span> Broadcast</h2>

        <div className="relative mx-auto" style={{ maxWidth: 640 }}>
          <div className="relative rounded-[28px] bg-gradient-to-b from-[#2a2a2e] to-[#141416] p-5 sm:p-7 border border-white/10 shadow-2xl">
            <div className="relative rounded-[14px] overflow-hidden bg-black aspect-[4/3]">
              {TV_VIDEO ? (
                <video ref={ref} src={TV_VIDEO} autoPlay muted loop playsInline className="h-full w-full object-cover" data-testid="retro-tv-video" />
              ) : (
                <div className="absolute inset-0 tv-static grid place-items-center">
                  <span className="overline text-white/50">◉ NO SIGNAL — feed incoming</span>
                </div>
              )}
              <div className="absolute inset-0 tv-scanlines pointer-events-none" />
              <div className="absolute inset-0 pointer-events-none" style={{ boxShadow: "inset 0 0 80px rgba(0,0,0,0.7)" }} />
              <span className="absolute top-3 left-3 overline text-primary tv-glitch">● REC · WIGGLEZ TV</span>
              <div className="absolute bottom-3 left-0 right-0 overflow-hidden">
                <div className="tv-ticker whitespace-nowrap text-secondary font-modern text-sm">
                  {[...TICKER, ...TICKER].map((t, i) => (<span key={i} className="mx-6">{t} ✦</span>))}
                </div>
              </div>
            </div>
            <div className="flex items-center justify-between mt-4 px-1">
              <div className="flex gap-2">
                <span className="h-4 w-4 rounded-full bg-white/15" />
                <span className="h-4 w-4 rounded-full bg-white/15" />
              </div>
              {TV_VIDEO && (
                <button onClick={toggle} data-testid="retro-tv-sound" className="inline-flex items-center gap-2 overline text-white/70 hover:text-white transition-colors">
                  {muted ? <SpeakerSimpleX size={16} /> : <SpeakerSimpleHigh size={16} />} {muted ? "Unmute" : "Mute"}
                </button>
              )}
              <div className="h-6 w-10 rounded bg-white/10" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
